import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';
import { strUserIdSelector } from 'src/selectors/auth';
import { trackingZShort } from 'src/utils/tracking';

export const useTracking = (shortId: number, source: string = '', extra: string = '') => {
    const strUserId = useSelector(strUserIdSelector);
    const router = useRouter();
    const isTrigger = useRef<boolean>(false);
    const [inViewRef, inView] = useInView({ threshold: 0.75 });

    router.events?.on('routeChangeComplete', () => {
        isTrigger.current = false;
    });

    useEffect(() => {
        if (inView && source && !isTrigger.current) {
            trackingZShort(shortId, source, strUserId, extra);
            isTrigger.current = true;
        }
    }, [inView]);

    return [inViewRef, inView];
};
